import { Link } from 'react-router-dom';

export default function FinalCta() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="relative rounded-xl bg-gradient-to-br from-surface via-white to-accentMuted/30 border border-border p-10 md:p-16 text-center overflow-hidden">
          {/* Subtle decorative element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-accentMuted/30 to-transparent rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" />

          <div className="relative">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary leading-tight mb-6">
              まずは、伝えたいことを
              <br className="hidden sm:block" />
              入力するだけ。
            </h2>
            <p className="text-base md:text-lg text-textMuted leading-relaxed max-w-xl mx-auto mb-10">
              まだ内容が整理できていなくても大丈夫です。
              <br className="hidden md:block" />
              ChatLP なら、会話しながらLPの形にしていけます。
            </p>
            <Link to="/auth/sign-in?redirectTo=/app/wizard" className="app-btn-primary">
              無料で試す
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
